<template>

</template>


<script>

export default {

    name: 'ViewLogout',

    mounted() {
        this.$auth.logout({
            success: () => {
                this.$alert.success('Wylogowano', 'Użytkownik został wylogowany pomyślnie.')
            }
        })
    }

}

</script>
